import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, ClipboardCheck } from "lucide-react";
import MoleculeViewer from "../components/MoleculeViewer";

export default function TopicDetail() {
  const { id } = useParams();
  const [topic, setTopic] = useState(null);
  const [molecule, setMolecule] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setTopic(null);
    setMolecule(null);
    setErr(null);
    api.get(`/topics/${id}`).then((r) => setTopic(r.data)).catch(() => setErr("Topic not found"));
    api.get(`/topics/${id}/molecule`).then((r) => setMolecule(r.data)).catch(() => {});
  }, [id]);

  if (err) {
    return <div className="text-slate-400">{err}</div>;
  }
  if (!topic) {
    return <div className="text-slate-400">Loading…</div>;
  }

  return (
    <div className="space-y-8" data-testid="topic-detail-root">
      <div>
        <Link to="/topics" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-slate-400 hover:text-cyan-300" data-testid="back-to-topics">
          <ArrowLeft size={14} /> All topics
        </Link>
        <h1 className="font-display mt-4 text-4xl font-bold tracking-tight sm:text-5xl">{topic.title}</h1>
        <p className="mt-3 max-w-3xl text-slate-300">{topic.summary}</p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <article className="space-y-6 md:col-span-2">
          {topic.sections.map((s, i) => (
            <section key={s.heading} className="rounded-md border border-white/10 bg-black/40 p-6" data-testid={`section-${i}`}>
              <div className="font-mono-num text-[10px] uppercase tracking-widest text-cyan-300">Section {String(i + 1).padStart(2, "0")}</div>
              <h2 className="font-display mt-2 text-2xl font-semibold text-white">{s.heading}</h2>
              <p className="mt-3 text-slate-300 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </article>

        <aside className="space-y-4">
          {molecule && <MoleculeViewer molecule={molecule} />}
          <div className="rounded-md border border-white/10 bg-black/40 p-5">
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Key terms</div>
            <div className="mt-3 flex flex-wrap gap-2" data-testid="key-terms">
              {topic.key_terms?.map((k) => (
                <span key={k} className="rounded-full border border-cyan-400/30 bg-cyan-500/5 px-3 py-1 text-xs text-cyan-200">
                  {k}
                </span>
              ))}
            </div>
          </div>
          <Link
            to={`/quiz/${topic.id}`}
            data-testid="start-topic-quiz-btn"
            className="flex items-center justify-between rounded-md border border-cyan-400/40 bg-cyan-500/10 p-5 transition-colors hover:bg-cyan-500/15"
          >
            <div>
              <div className="text-xs uppercase tracking-widest text-cyan-300">Test your knowledge</div>
              <div className="font-display mt-1 text-lg font-semibold text-white">Start the quiz</div>
            </div>
            <ClipboardCheck className="text-cyan-300" />
          </Link>
        </aside>
      </div>
    </div>
  );
}
